const Types = {
    SHOW_ALERT: 'SHOW_ALERT',
    HIDE_ALERT: 'HIDE_ALERT',
}

const INITIAL_STATE = {
      showAlert: false,
      alertType: '',
      alertMessage: ''
}



export const showAlert = (type, message) => {
    return dispatch => {
      dispatch(show(type, message));
      setTimeout(() => {
        dispatch(hide())
      }, 3000);
    }
}

const show = (type, message) => {
    return { type: Types.SHOW_ALERT, payload: {type, message}}
}
export const hide = () => {
    return { type: Types.HIDE_ALERT}
}


const alert = (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case Types.SHOW_ALERT:
        return {showAlert: true, alertType: action.payload.type, alertMessage: action.payload.message};
        break
      case Types.HIDE_ALERT:
        return {showAlert: false, alertType: '', alertMessage: 'danger'}
      default:
        return state;
    }
}
export default alert;